import React from 'react';
import styled from 'styled-components';
import { IconButton } from 'components/Shared/Buttons';
import { MAPTOOLBAR } from 'theme';

const StyledMapToolbarControl = styled(IconButton)`
    width: ${MAPTOOLBAR.BUTTON.WIDTH};
    height: ${MAPTOOLBAR.BUTTON.HEIGHT};
    color: #666;
    font-size: 1.5em;
    vertical-align: middle;
`;

const MapToolbarControl = (props) => {
    return <StyledMapToolbarControl {...props} />;
};

export default MapToolbarControl;
